import axios from 'axios'
import qs from 'qs'

// Astro not login settings
export class ApiGoogleApiService {
  constructor (config) {
    this.config = config

    return this.createAxiosInstance()
  }

  /*
   * refreshToken処理部分省略
   */

  interceptorRequestConfig (config) {
    return config
  }
  interceptorRequestError (error) {
    return Promise.reject(error)
  }
  interceptorResponseConfig (response) {
    return response
  }
  async interceptorResponseError (error) {
    // ログイン前のAPIなのでリフレッシュトークン関連はせずにエラーハンドリング
    return this.responseErrorHandling(error)
  }
  createAxiosInstance () {
    const axiosInstance = axios.create(this.config)
    axiosInstance.interceptors.request.use(
      this.interceptorRequestConfig.bind(this),
      this.interceptorRequestError.bind(this)
    )
    axiosInstance.interceptors.response.use(
      this.interceptorResponseConfig.bind(this),
      this.interceptorResponseError.bind(this)
    )
    return {
      get (url, config = {}) {
        if ('params' in config) {
          config.paramsSerializer = (params) => {
            return qs.stringify(params, { arrayFormat: 'repeat' })
          }
        }
        return axiosInstance.get(`${url}`, config)
      },
      delete (url, config = {}) {
        return axiosInstance.delete(url, config)
      },
      post (url, data, config = {}) {
        return axiosInstance.post(`${url}`, data, config)
      },
      put (url, data, config = {}) {
        return axiosInstance.put(`${url}`, data, config)
      },
      patch (url, data, config = {}) {
        return axiosInstance.patch(`${url}`, data, config)
      }
    }
  }
  responseErrorHandling (error) {
    return Promise.reject(error)
  }
}
export const GoogleApiInterface = new ApiGoogleApiService({
  baseURL: 'https://maps.googleapis.com/maps/api/geocode/json',
  headers: {
    'Content-Type': 'application/json'
  },
  timeout: 30000
})



// WEBPACK FOOTER //
// ./src/config/googleMap.js